// extracted by mini-css-extract-plugin
module.exports = {"note":"_727fe9e","icon":"_6564f025","text":"_b74e3073","gridView":"_fd9506bb","disabled":"_eb5a519e","edit":"_f7c38952","noteContent":"_8c731837","add":"_7e0a636f"};